import styled from 'styled-components'

interface OptionsProps {
  isOpen: boolean
}

export const Options = styled.ul<OptionsProps>`
  list-style: none;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  width: 270px;
  background-color: white;
  box-shadow: 0 5px 16px rgb(130 130 130 / 16%);
  border-radius: 10px;
  right: 0;
  top: 76px;
  li:last-child {
    border: none;
    p {
      color: ${({ theme }) => theme.color.text.brand.default};
    }
    > svg {
      margin-right: 20px;
    }
  }
`

export const Option = styled.li`
  padding: 12px 15px;
  display: flex;
  align-items: center;
  border-bottom-width: ${({ theme }) => theme.border.width.thin};
  border-bottom-style: ${({ theme }) => theme.border.style.solid};
  border-bottom-color: #f8f9fb;

  > svg {
    margin-right: 12px;
  }

  :hover p {
    text-decoration: underline;
  }
`
